/**
 * Nordic Park — Product FAQ Accordion
 */
(function () {
  // Ensure all collapsed panels start inert (links inside leave the tab order)
  document.querySelectorAll('.np-faq .np-faq__item:not(.is-open) .np-faq__answer')
    .forEach(function (a) { a.inert = true; });

  document.querySelectorAll('.np-faq .np-faq__question').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.np-faq__item');
      var section = button.closest('.np-faq');
      var isOpen = item.classList.contains('is-open');

      // Close all (within this FAQ section only)
      section.querySelectorAll('.np-faq__item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        openItem.querySelector('.np-faq__question').setAttribute('aria-expanded', 'false');
        var openAns = openItem.querySelector('.np-faq__answer');
        if (openAns) openAns.inert = true;
      });

      // Toggle clicked
      if (!isOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        var ans = item.querySelector('.np-faq__answer');
        if (ans) ans.inert = false;
      }
    });
  });
})();
